import { Scene } from "phaser"
import { CONST } from "../../CONST"  
import { SIM_CLICK_PRE_ANIM_DURATION } from "./Key"
import { GameState } from "../../scenes/InstrumentScene"

const CONFIG = {
    startPosition: {x: 400, y: 255},
    head: {xOffset: -3, yOffset: -32},
    leftHand: {xOffset: 45, yOffset: -10},
    rightHandTop: {xOffset: -53, yOffset: -13},
    rightHandBottom: {xOffset: -120, yOffset: 9},
}

const ANIMATION_CONFIG: any = {
    1: {charX: 320, charY: 240},
    2: {charX: 392, charY: 248},
    3: {charX: 464, charY: 256},
    4: {charX: 535, charY: 265},
    5: {charX: 606, charY: 273},
    6: {charX: 679, charY: 281},
    7: {charX: 750, charY: 290},
    idle: {charX: 350, charY:255},
    playStart: {charX: 500, charY:260}
} 

export class Character {
    scene: Phaser.Scene;
    state: GameState;

    character: Phaser.GameObjects.Image;
    leftHand: Phaser.GameObjects.Image;
    rightHandTop: Phaser.GameObjects.Image;
    rightHandBottom: Phaser.GameObjects.Image;
    head: Phaser.GameObjects.Image;

    rightHandAnim!: Phaser.Tweens.Tween;
    leftHandAnim!: Phaser.Tweens.Tween;



    constructor(scene : Phaser.Scene, gameState: GameState){
        this.scene = scene;
        this.state = gameState;
        this.updateState(gameState);

        //Add images
        this.character = this.scene.add.image(CONFIG.startPosition.x, CONFIG.startPosition.y, CONST.INSTRUMENT.CHARACTER_BODY).setDepth(5).setOrigin(0.7, 0.18);
        this.leftHand = this.scene.add.image(0, 0, CONST.INSTRUMENT.HAND_LEFT).setDepth(4).setOrigin(0.06, 0.72);
        this.rightHandTop = this.scene.add.image(0, 0, CONST.INSTRUMENT.HAND_RIGHT_TOP).setDepth(7).setOrigin(0.85, 0.70);
        this.rightHandBottom = this.scene.add.image(0, 0, CONST.INSTRUMENT.HAND_RIGHT_BOTTOM).setDepth(17).setOrigin(0.37, 0.35);
        this.head = this.scene.add.image(0, 0, CONST.INSTRUMENT.CHARACTER_HEAD).setDepth(6).setOrigin(0.4, 0.90);
        this.updateBodyPosition();

        this.scene.events.on('update', this.update, this);
    }

    updateState(newState: number) {
        if (newState == GameState.Playing){
            this.startPlayingAnimation(); 
        } else if (newState == GameState.Listening){
        } else if (newState == GameState.Transitioning){
            if (this.state == GameState.Listening){
                //Going from listening to playing
                this.transitionAnimationListenToPlay();
            } else if (this.state == GameState.Playing){
                //Going from playing to listening
                this.startIdleAnimation();
            }
        }

        this.state = newState;
    }

    private startIdleAnimation(){
        this.scene.time.addEvent({
            delay: 500,
            callback: () => {
                //Move character to center
                //Rotate hands down
                this.stopRightHandAnim();

                //Character move
                this.scene.tweens.add({
                    targets: this.character,
                    x: ANIMATION_CONFIG.idle.charX,
                    y: ANIMATION_CONFIG.idle.charY,
                    ease: 'Quad.easeInOut', 
                    duration: 500,
                    repeat: 0,
                    yoyo: false,
                });

                this.stopLeftHandAnim();
                this.leftHandAnim = this.scene.tweens.add({
                        targets: this.leftHand,
                        angle: 50,
                        ease: 'Cubic.easeInOut', 
                        duration: 500,
                });

                this.stopRightHandAnim();
                this.rightHandAnim = this.scene.tweens.add({
                    targets: this.rightHandBottom,
                    angle: -90,
                    ease: 'Cubic.easeInOut', 
                    duration: 1000,
                });
            },
            callbackScope: this
        });
    }

    private startPlayingAnimation(){
        this.startLeftHandAnim();      
        this.startRightHandAnim(); 
       
    }

    private transitionAnimationListenToPlay(){
         //Character move
         this.scene.tweens.add({
            targets: this.character,
            x: ANIMATION_CONFIG.playStart.charX,
            y: ANIMATION_CONFIG.playStart.charY,
            ease: 'Quad.easeInOut', 
            duration: 500,
            repeat: 0,
            yoyo: false,
            delay: 300,
        });
        this.stopLeftHandAnim();
        this.leftHandAnim = this.scene.tweens.add({
                targets: this.leftHand,
                angle: 0,
                ease: 'Cubic.easeInOut', 
                duration: 1000,
        });

        this.stopRightHandAnim();
        this.rightHandAnim = this.scene.tweens.add({
                targets: this.rightHandBottom,
                angle: 0,
                ease: 'Cubic.easeInOut', 
                duration: 1000,
        });
    }

    private updateBodyPosition(){
        var updateBodyPart = (img: Phaser.GameObjects.Image, origin : Phaser.GameObjects.Image, conf: {xOffset: number, yOffset: number}, followRotation: boolean = false) => {
            img.setPosition(origin.x + conf.xOffset, origin.y + conf.yOffset);
            if (followRotation) img.setRotation(origin.rotation);
        }
        updateBodyPart(this.leftHand, this.character, CONFIG.leftHand);
        updateBodyPart(this.rightHandTop, this.character, CONFIG.rightHandTop);
        updateBodyPart(this.rightHandBottom, this.rightHandTop, CONFIG.rightHandBottom);
        updateBodyPart(this.head, this.character, CONFIG.head);
    }

    private startLeftHandAnim(){
        this.stopLeftHandAnim();
        this.leftHandAnim = this.scene.tweens.add({
                targets: this.leftHand,
                angle: -5,
                ease: 'Cubic.easeInOut', 
                duration: 1000,
                repeat: -1,
                yoyo: true,
        });
    }

    private stopLeftHandAnim(){
        if (this.leftHandAnim) this.leftHandAnim.stop();
    }

    private startRightHandAnim(){
        this.stopRightHandAnim();

        this.rightHandAnim =  this.scene.tweens.add({
                    targets: this.rightHandBottom,
                    angle: -4,
                    ease: 'Cubic.easeInOut', 
                    duration: 1000,
                    repeat: -1,
                    yoyo: true,
        });
    }

    private stopRightHandAnim(){
        if (this.rightHandAnim) this.rightHandAnim.stop();
    }

    public animateNote(note: {key: number, time: number}){
        var fullTime = SIM_CLICK_PRE_ANIM_DURATION;

        //Character move
        this.scene.tweens.add({
            targets: this.character,
            x: ANIMATION_CONFIG[note.key].charX,
            y: ANIMATION_CONFIG[note.key].charY,
            ease: 'Quad.easeInOut', 
            duration: fullTime*0.9,
            repeat: 0,
            yoyo: false,
        });


        this.stopRightHandAnim();

        //Right hand move up
        this.scene.tweens.add({
                    targets: this.rightHandBottom,
                    angle: -20,
                    ease: 'Cubic.easeInOut', 
                    duration: fullTime*0.1,
                    repeat: 0,
                    delay: fullTime-fullTime*0.25,
                    yoyo: false,
        });

        //Right hand strike
        this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: 20,
            ease: 'Cubic.easeInOut',
            duration: fullTime*0.15, //Maybe fix it at like 50ms?
            repeat: 0,
            yoyo: false,
            delay: fullTime-fullTime*0.15, //same as duration
        });

         //Right hand reset
         this.scene.tweens.add({
            targets: this.rightHandBottom,
            angle: 0,
            ease: 'Cubic.easeInOut',
            duration: fullTime*0.2, //Maybe fix it at like 50ms?
            repeat: 0,
            yoyo: false,
            delay: fullTime, //same as duration
            onComplete: function () {
                this.startRightHandAnim();
            },
            onCompleteScope: this,

        });
    }

    private update(){
        this.updateBodyPosition();
    }
}